import React from 'react';
import { useSelector } from 'react-redux';

import { Crud } from 'core/components/Crud';
import Detalle from './Detalle';
import List from 'store/List';
import Auth from 'store/Auth';
import { Button } from '@mui/material';

import * as enums from 'core/enums';
import { ENTITY_BODEGA } from '../../../store/entities/constants';
import * as icons from '../../../core/icons';
import { Tag } from '../../../core/components';
import { statesEntity } from 'core/enums';

const columns = items => [
    {
        titleFilter:
            'Nombre, Denominación, NIF, Dirección, Población, Provincia, Notas',
        type: 'text',
        width: '3',
        modificador: '=',
        filter: (valor, modificador) =>
            items.filter(
                [
                    'id',
                    'nombre',
                    'nombreComercial',
                    'nif',
                    'direccion',
                    'poblacion',
                    'provincia',
                    'notas'
                ],
                valor,
                '',
                'text',
                modificador
            )
    },
    {
        titleFilter: 'Censo',
        type: 'text',
        width: 3,
        modificador: '=',
        options: enums.censos.filter(c => c.value),
        filter: (valor, modificador) =>
            items.filter(['censo'], valor, 'in', 'text', modificador)
    },
    {
        titleFilter: 'Forma Juridica',
        type: 'text',
        width: 3,
        modificador: '=',
        options: {
            api: 'auxiliares/formasjuridicas',
            field: 'descripcion',
            icon: icons.FormaJuridicaIcon,
            color: 'gray'
        },
        filter: (valor, modificador) =>
            items.filter(
                [['formaJuridica', 'descripcion']],
                valor,
                'in',
                'text',
                modificador
            )
    },
    {
        titleFilter: 'Estado',
        type: 'text',
        width: 3,
        modificador: '=',
        defaultValue: ['Activo'],
        options: enums.statesEntity.filter(c => c.value),
        filter: (valor, modificador) =>
            items.filter(['estado'], valor, 'in', 'text', modificador)
    },
    {
        column: 'nif',
        title: 'NIF',
        type: 'text'
    },
    {
        column: 'nombre',
        title: 'Razón Social',
        type: 'text'
    },
    {
        column: 'nombreComercial',
        title: 'Denominación',
        type: 'text'
    },
    {
        column: 'direccion',
        title: 'Direccion',
        type: 'text'
    },
    {
        column: 'poblacion',
        title: 'Poblacion',
        type: 'text'
    },
    {
        column: 'provincia',
        title: 'Provincia',
        type: 'text'
    },
    {
        column: 'estado',
        title: 'Estado',
        type: 'text',
        align: 'center',
        hideValue: true,
        width: '8%',
        component: item => (
            <Tag
                align={'center'}
                size={'small'}
                sx={{
                    color: enums.getItem(statesEntity, item.estado, 'color')
                }}
                Icon={enums.getItem(statesEntity, item.estado, 'icon')}
                value={item.estado}
            />
        )
    }
];

const CrudContainer = List(Auth(Crud, 'auth'), 'entities', 'bodegas');

const Bodegas = props => {
    const { ...rest } = props;
    const entityData = useSelector(state => state.entities[ENTITY_BODEGA]);

    return (
        <CrudContainer
            single
            entityData={entityData}
            columns={columns}
            Detalle={Detalle}
            {...rest}
        />
    );
};

export default Bodegas;
